// Copyright (c) 2022 by Move Closer

import { AbstractSetDriver, RelatedType, SetDescription } from '../../shared/related'

import { ContentData } from '../contracts'

import { ContentRelatedType } from './content'

/**
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
export class ArticlesDriver extends AbstractSetDriver<SetDescription, ContentData> {
  protected childType: RelatedType = ContentRelatedType
  protected dependencies: RelatedType[] = [ContentRelatedType]
  protected key: RelatedType = ArticlesRelatedType
}

export const ArticlesRelatedType: RelatedType = 'articles'
